function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n        .st0{fill:#ED1C24;}\n        .st1{fill:#009245;}\n        .st2{fill:#F0F0F0;}\n    ");

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Italy (2)");

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  id: "Italy"
}, React.createElement("circle", {
  className: "st0",
  cx: 15,
  cy: 15,
  r: 15
}), React.createElement("path", {
  className: "st1",
  d: "M15,0C6.7,0,0,6.7,0,15s6.7,15,15,15V0z"
}), React.createElement("path", {
  className: "st2",
  d: "M15,0c-1.7,0-3.4,0.3-5,0.9v28.3c3.2,1.2,6.8,1.2,10,0V0.9C18.4,0.3,16.7,0,15,0z"
})));

var SvgItaly = function SvgItaly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "fi_9906483",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgItaly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/italy.4815396b.svg";
export { ForwardRef as ReactComponent };